jQuery(document).ready(function ($) {
  $("[data-buyers-toggle]").on("click", function (e) {
    $("[data-buyers-toggle]").not(this).parent().removeClass("active");
    $(this).parent().toggleClass("active");
    $(this).parent().find("[data-anchor]").get(0).scrollIntoView({
      behavior: "smooth",
    });
  });

  const carousels = document.querySelectorAll("[data-buyers-carousel]");
  carousels.forEach((carousel) => {
    const tags = carousel.querySelectorAll("[data-buyers-scroll-to-tag]");
    tags.forEach((tag) => {
      tag.addEventListener("click", (e) => {
        e.preventDefault();
        const id = tag.dataset.buyersScrollToTag;
        const itemAnchor = carousel.querySelector(
          `[data-buyers-item-tag="${id}"] [data-buyers-item-anchor]`,
        );

        tags.forEach((tag) => {
          tag.classList.remove("active");
        });

        tag.classList.add("active");

        if (itemAnchor) {
          itemAnchor.scrollIntoView({
            behavior: "smooth",
            inline: "start",
            block: "start",
          });
        }
      });
    });

    let debounceTimer = null;
    const scroller = carousel.querySelector(".buyers-carousel__list");
    scroller.addEventListener(
      "scroll",
      () => {
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(() => {
          const scrollLeft = scroller.scrollLeft;
          const items = Array.from(
            carousel.querySelectorAll("[data-buyers-item-tag]"),
          );
          items.every((item) => {
            const x = item.offsetLeft;

            //console.log('scrollLeft:', scrollLeft)
            //console.log('itemX:', x, item.dataset.buyersItemTag)

            if (
              scroller.scrollWidth - scroller.scrollLeft ===
              scroller.clientWidth
            ) {
              const newTag = carousel.querySelector(
                `[data-buyers-scroll-to-tag]:last-child`,
              );
              tags.forEach((tag) => {
                tag.classList.remove("active");
              });

              if (newTag) {
                newTag.classList.add("active");
              }
            } else if (x >= scrollLeft) {
              const newTag = carousel.querySelector(
                `[data-buyers-scroll-to-tag="${item.dataset.buyersItemTag}"]`,
              );
              tags.forEach((tag) => {
                tag.classList.remove("active");
              });

              if (newTag) {
                newTag.classList.add("active");
              }
              return false;
            } else {
              return true;
            }
          });
        }, 100);
      },
      { passive: true },
    );
  });
});
